<template>
    <div>
        <div v-if="isPc" class="brand-container">
            <div class="left-wrap">
                <!-- Swiper容器 -->
                <div class="swiper brand-swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in sliderList" :key="index">
                            <img class="swiper-slide-image swiper-lazy loading-bg" :data-src="item.img + '.webp'" alt=""
                                @click="handleImageClick(item)" />
                            <div class="swiper-lazy-preloader"></div>
                        </div>
                    </div>
                    <!-- 导航按钮 -->
                    <div class="swiper-button-prev" @click="handleNavClick('prev')"></div>
                    <div class="swiper-button-next" @click="handleNavClick('next')"></div>
                </div>

                <!-- 奖项容器 -->
                <div class="award-container">
                    <div class="award-content" v-if="awardInfo && awardInfo.title">
                        <div class="award-details">
                            <a :href="awardInfo.link" class="award-title" @click="handleClickLink(awardInfo)">{{
                                awardInfo.title }}</a>
                            <span class="award-subtitle">{{ awardInfo.desc }}</span>
                        </div>
                        <span class="award-date">{{ awardInfo.date }}</span>
                    </div>
                </div>
            </div>
            <div class="right-wrap">
                <div class="frame" v-if="textList && textList.length">
                    <div class="swiper vertical-swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item, index) in textList" :key="index">
                                <div class="content-container">
                                    <div class="text-container">
                                        <a :href="item.url" class="text" :class="{ link: item.url }" @click="handleVerticalItemClick(item)">{{ item.title
                                        }}</a>
                                    </div>
                                    <div class="date-container">
                                        <span class="date-text">{{ item.date }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="mob-brand-container">
            <transition-group name="list" tag="div" class="items-container">
                <div class="item" v-for="(item, index) in displayedMobItems" :key="item.link"
                    :class="{ 'last-item': index === displayedMobItems.length - 1 }">
                    <div class="time">{{ item.date }}</div>
                    <div class="mob-content">
                        <div class="line" :class="{ tapered: index === displayedMobItems.length - 1 }"></div>
                        <div class="mob-title" @click="handleMobClick(item)">
                            {{ item.title }}
                        </div>
                        <div class="mob-desc">{{ item.desc }}</div>
                        <img class="brand-img" :src="item.img" alt="" v-if="item.img" @click="handleMobClick(item)" />
                    </div>
                </div>
            </transition-group>
            <div class="expand-btn" v-if="hasMoreItems" @click="toggleExpand">
                <i :class="[isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i>
            </div>
        </div>
    </div>
</template>
<script>
import Swiper from "@pc/components/libs/swiper/swiper.6.5.0.js";
import "@pc/components/libs/swiper/swiper.6.5.0.css";
import { dataReport } from "../../../../../../utils/report";
// import 'typeface-roboto'
export default {
    props: {
        isPc: {
            type: Boolean,
            default: true,
        },
        brandInfo: {
            type: Array,
            default: () => [],
        },
        type: {
            type: String,
            default: 'mixed',
        },
    },
    data() {
        return {
            isComputed: [],
            isExpanded: false, // 添加展开状态
            lineHeights: [], // 存储每个线条的高度
            currentSwiperIndex: 0, // 添加当前轮播索引
            swiperInstance: null, // 添加Swiper实例引用
            verticalSwiperInstance: null, // 垂直轮播实例
            configData: {
                img: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20251110110656-25dbadf9-3676-46b5-b2b4-78338dfabecf.png",
            }
        };
    },
    methods: {
        toggleExpand() {
            dataReport(
                    {
                        hottag: "FQL_HOME_MOB_BRAND_EXPAND_BUTTON_CLICK",
                        eventPosName: `分期乐移动端首页品牌展开按钮点击`,
                        eventType: 2, // 点击
                    }
                );
            this.isExpanded = !this.isExpanded;
        },
        handleImageClick() {
            // 获取当前轮播图对应的awardInfo
            const currentAwardInfo = this.awardInfo;

            if (currentAwardInfo && currentAwardInfo.link) {
                // 调用dataReport进行埋点，与handleClickLink方法保持一致
                dataReport(
                    {
                        hottag: "FQL_HOME_WEB_BRAND_IMG_CLICK",
                        eventPosName: `分期乐web首页品牌图片点击`,
                        eventType: 2, //点击品牌
                    },
                    { targetLink: currentAwardInfo.link }
                );

                // 跳转到链接
                window.location.href = currentAwardInfo.link;
            }
        },
        handleMobClick(item) {
            if (item.link) {
                dataReport(
                    {
                        hottag: "FQL_HOME_MOB_BRAND_CLICK",
                        eventPosName: `分期乐移动端首页品牌点击`,
                        eventType: 2, //点击品牌
                    },
                    { targetLink: item.link }
                );
                window.location.href = item.link;
            }
        },
        handleClickLink(link) {
            if (link.url) {
                dataReport(
                    {
                        hottag: "FQL_HOME_WEB_BRAND_CLICK",
                        eventPosName: `分期乐web首页品牌点击`,
                        eventType: 2, //点击品牌
                    },
                    { targetLink: link.url }
                );
            }
        },
        // 添加导航按钮点击埋点
        handleNavClick(direction) {
            dataReport(
                {
                    hottag: `FQL_HOME_WEB_BRAND_NAV_CLICK`,
                    eventPosName: `分期乐web首页品牌左右导航点击`,
                    eventType: 2, //点击
                },
                { direction }
            );
        },
        // 添加垂直轮播项点击埋点
        handleVerticalItemClick(item) {
            dataReport(
                {
                    hottag: "FQL_HOME_WEB_BRAND_VERTICAL_ITEM_CLICK",
                    eventPosName: `分期乐web首页品牌垂直列表项点击`,
                    eventType: 2, //点击
                },
                { item }
            );
        },
        initSwiper() {
            new Swiper(".brand-swiper-container", {
                // Optional parameters
                direction: "horizontal",
                loop: true,
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                lazy: {
                    loadPrevNext: true, // 修改为预加载前后图片
                    loadOnTransitionStart: false, // 修改为切换开始时不加载
                    loadPrevNextAmount: 1, // 预加载数量
                },
                preloadImages: false,
                on: {
                    slideChange: (swiper) => {
                        this.currentSwiperIndex = swiper.realIndex;
                    },
                },
            });
        },
        // 初始化垂直轮播
        initVerticalSwiper() {
            // 销毁已存在的实例
            if (this.verticalSwiperInstance) {
                this.verticalSwiperInstance.destroy();
                this.verticalSwiperInstance = null;
            }
            
            // 根据模式设置不同的Swiper配置
            let swiperConfig = {
                direction: "vertical",
                loop: true,
                speed: 10000,
                grabCursor: true,
                longSwipes: true,
                simulateTouch: true,
                touchEventsTarget: "container",
                slidesPerView: "auto",
                freeMode: false,
                preventClicks: true,
                preventClicksPropagation: true,
                followFinger: true,
                allowTouchMove: true,
            };
            
            // 根据不同的模式设置配置
            switch (this.type) {
                case 'auto':
                    // 自动滚动但不能交互
                    swiperConfig.autoplay = {
                        delay: 0,
                        disableOnInteraction: true, // 禁用交互后继续自动播放
                        stopOnLastSlide: false,
                        waitForTransition: true,
                        reverseDirection: false,
                        pauseOnMouseEnter: false, // 鼠标悬停不暂停
                    };
                    swiperConfig.allowTouchMove = false; // 禁止触摸移动
                    swiperConfig.grabCursor = false; // 禁用抓手图标
                    break;
                    
                case 'manual':
                    // 手动滚动，无自动播放
                    swiperConfig.loop = false;
                    swiperConfig.autoplay = false;
                    swiperConfig.speed = 300; // 手动滑动速度更快
                    break;
                    
                case 'mixed':
                default:
                    // 混合模式（当前实现）
                    swiperConfig.autoplay = {
                        delay: 0,
                        disableOnInteraction: false, // 交互后继续自动播放
                        stopOnLastSlide: false,
                        waitForTransition: true,
                        reverseDirection: false,
                        pauseOnMouseEnter: true, // 鼠标悬停时暂停
                    };
                    break;
            }
            
            this.verticalSwiperInstance = new Swiper(".vertical-swiper-container", swiperConfig);
        },
        // 移动端品牌项曝光埋点
        reportMobItemsExposure() {
            if (this.mobItems && this.mobItems.length > 0) {
                dataReport(
                    {
                        hottag: "FQL_HOME_MOB_BRAND_ITEMS_EXPOSURE",
                        eventPosName: `分期乐移动端首页品牌项曝光`,
                        eventType: 1, // 曝光
                    },
                    { itemList: this.mobItems }
                );
            }
        },
        // 展开按钮曝光埋点
        reportExpandButtonExposure() {
            if (this.hasMoreItems) {
                dataReport(
                    {
                        hottag: "FQL_HOME_MOB_BRAND_EXPAND_BUTTON_EXPOSURE",
                        eventPosName: `分期乐移动端首页品牌展开按钮曝光`,
                        eventType: 1, // 曝光
                    }
                );
            }
        }
    },
    computed: {
        displayedMobItems() {
            if (this.mobItems?.length > 4 && !this.isExpanded) {
                return this.mobItems.slice(0, 4);
            } else {
                return this.mobItems;
            }
        },
        hasMoreItems() {
            return this.mobItems?.length > 4;
        },
        sliderList() {
            return this.brandInfo?.[1]?.map?.((item) => ({
                img: item?.img,
            }));
        },
        awardInfo() {
            const awardList =
                this.brandInfo?.[2]?.map?.((item) => ({
                    title: item?.title,
                    desc: item?.desc,
                    date: item?.date,
                    link: item?.title_link,
                })) || [];
            return awardList?.[this.currentSwiperIndex];
        },
        textList() {
            return this.brandInfo?.[3]?.map?.((item) => ({
                url: item?.title_link,
                title: item?.title,
                date: item?.date,
            }));
        },
        mobItems() {
            return this.brandInfo?.[4]?.map?.((item) => ({
                date: item?.date,
                desc: item?.dec,
                img: item?.img,
                title: item?.text,
                link: item?.link,
            }));
        },
    },
    watch: {
        brandInfo: {
            handler(newVal) {
                if (newVal && newVal[1] && newVal[1].length > 0) {
                    // 确保数据存在，再初始化 Swiper
                    this.$nextTick(() => {
                        this.initSwiper();
                    });
                }
                // 初始化垂直轮播
                if (newVal && newVal[3] && newVal[3].length > 0) {
                    this.$nextTick(() => {
                        this.initVerticalSwiper();
                    });
                }
            },
            immediate: true, // 立即执行一次
            deep: true,
        },
        mobItems: {
            handler(newVal) {
                this.reportMobItemsExposure();
                this.reportExpandButtonExposure();
            },
        },
    },
    mounted() {
    },
    beforeUnmount() {
        // 组件卸载前销毁轮播实例，避免内存泄漏
        if (this.verticalSwiperInstance) {
            this.verticalSwiperInstance.destroy();
        }
    },
};
</script>

<style scoped>
.brand-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0;
}

.brand-swiper-container {
    width: 586px;
    height: 328px;
    overflow: hidden;
    position: relative;
}

.swiper-slide-image {
    width: 100%;
    height: auto;
    cursor: pointer;
}

.award-container {
    display: flex;
    flex-direction: column;
    width: 586px;
    padding: 24px 30px 36px;
    background: white;
}

.award-content {
    width: 526px;
    height: 101px;
}

.award-details {
    display: flex;
    flex-direction: column;
}

.award-title {
    color: #4d83ff;
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 6px;
    line-height: 30px;
}

.award-subtitle {
    color: #676767;
    font-size: 16px;
    line-height: 24px;
    height: 48px;
    margin-bottom: 10px;
}

.award-date {
    color: #a0a0a0;
    font-size: 12px;
    line-height: 15px;
}

.frame {
    width: 586px;
    height: 489px;
    background-color: #fff;
    display: flex;
    align-items: flex-start;
    padding: 0;
    position: relative;
    overflow: hidden;
}

/* 垂直轮播容器样式 */
.vertical-swiper-container {
    width: 100%;
    height: 100%;
    padding: 30px;
}

/* 每个轮播项的样式 */
.content-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    padding-top: 20px;
}

.content-container {
    width: 526px;
    display: flex;
    flex-direction: column;
    align-items: flex;
    padding-bottom: 20px;
    border-bottom: 1px solid #dfdfdd;
    padding-top: 20px;
}

.last {
    border-bottom: 0;
}

.text-container {
    width: 100%;
    display: flex;
    align-items: flex-start;
    padding: 0;
    margin-bottom: 26px;
}

.text {
    width: 100%;
    color: #2f2f2f;
    font-family: "PingFang SC";
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
}

.date-container {
    width: 100%;
    padding: 0;
}

.date-text {
    width: 100%;
    color: #b8b8b8;
    font-family: "PingFang SC";
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
}

/* 导航按钮基础样式 */
.swiper-button-prev,
.swiper-button-next {
    width: 25.5px;
    /* 设置按钮宽度 */
    height: 25.5px;
    /* 设置按钮高度 */
    background-color: rgba(0, 0, 0, 0.3);
    /* 黑色背景，透明度0.3 */
    border-radius: 50%;
    /* 圆形按钮 */
    top: 50%;
    /* 垂直居中 */
    margin-top: -12.5px;
    /* 向上偏移按钮高度的一半，实现完美居中 */
    cursor: pointer; /* 添加鼠标指针 */
}

/* 箭头图标样式 */
.swiper-button-prev::after,
.swiper-button-next::after {
    font-size: 13px;
    /* 设置箭头图标大小 */
    color: white;
    /* 设置箭头颜色 */
}

/* 左右按钮位置调整 */
.swiper-button-prev {
    left: 10.5px;
    /* 左按钮距离左侧20px */
}

.swiper-button-next {
    right: 10.5px;
    /* 右按钮距离右侧20px */
}

.left-wrap {
    margin-right: 28px;
}

.link:hover {
    text-decoration: underline;
}

/* 轮播图加载状态背景色 */
.swiper-slide-image.loading-bg {
    /* 设置背景色（可替换为需要的颜色值） */
    background-color: #f5f5f5;
    /* 确保容器高度，避免塌陷（与轮播容器高度一致） */
    min-height: 330px;
}

/* 图片加载完成后移除背景色 */
.swiper-slide-image.swiper-lazy-loaded.loading-bg {
    background-color: transparent;
}

.frame .swiper .swiper-wrapper {
    transition: linear;
}

.frame .swiper .swiper-wrapper .swiper-slide {
    width: auto;
    height: auto;
}

.mob-brand-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.items-container {
    width: 100%;
    overflow: hidden;
}

.item {
    display: flex;
    flex-direction: row;
}

.list-enter-active, .list-leave-active {
    transition: all 0.5s ease;
}

.list-enter-from {
    opacity: 0;
    transform: translateY(30px);
}

.list-leave-to {
    opacity: 0;
    transform: translateY(-30px);
}

.expand-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    cursor: pointer;
}

.expand-btn i {
    transition: transform 0.3s ease;
}

.expand-btn i.expanded {
    transform: rotate(180deg);
}

.mob-content {
    position: relative;
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 25.7px;
    margin-left: 17.3px;
    padding-bottom: 20px;
}

.time {
    color: #3371ff;
    font-size: 18px;
    font-weight: 700;
    font-family: "Roboto";
    line-height: 23px;
}

.line {
    position: absolute;
    width: 0.5px;
    height: auto;
    background: #4d83ff;
    height: 100%;
    left: 0;
    top: 8px;
}

.line.tapered {
    background: linear-gradient(to bottom, #4d83ff 0%, transparent 100%);
}

.line::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    width: 6px;
    height: 6px;
    background: #4d83ff;
    /* 可根据实际需要更改颜色 */
}

.mob-title {
    line-height: normal;
    width: 228px;
    color: #3371ff;
    font-size: 14px;
    font-weight: 600;
    font-family: "OPPO Sans";
    margin-bottom: 8px;
}

.mob-desc {
    width: 228px;
    color: rgba(30, 37, 51, 0.6);
    font-size: 12px;
    font-weight: 400;
    font-family: "PingFang SC";
    margin-bottom: 8px;
    line-height: 20px;
}

.last-item .line {
    position: absolute;
    width: 0.5px;
    height: auto;
    background: linear-gradient(to bottom, #4d83ff 0%, transparent 100%);
    height: 70%;
    left: 0;
    top: 8px;
}

.brand-img{
    width: 196px;
    height: 86px;
}
</style>